export const getColoredSensors = (sensors) => {
  return sensors?.map((sensor) => ({ ...sensor, color: '#2db34a' }));
};
